<template>
  <column :md="4" :lg="6">
    <div class="home-sect-image">
      <div class="image">
        <img :src="`/static/images/landing/${image}.jpg`"/>
      </div>
    </div>
  </column>
</template>

<script>
export default {
  props: ['image', 'index'],
}
</script>

<style lang="scss">
@import '~style/variables';

.home-sect-image {
  .image {
    padding: 2rem;
    text-align: center;
    img {
      display: inline-block;
      max-width: 100%;
      width: auto;
    }
    @media screen and (min-width: $res-lg) {
      padding: 2rem 4rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/HomeSectImage.vue